import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { HiOutlineBars3, HiXMark } from "react-icons/hi2";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { LanguageContext } from "../../../context/LanguageContext";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

const NavbarButtons = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openLang, setOpenLang] = useState(false);
  const [openMobileLang, setOpenMobileLang] = useState(false);
  const [openYourMhero, setOpenYourMhero] = useState(false);
  const [openExploreMobile, setOpenExploreMobile] = useState(false);

  const { currentLang, setCurrentLang, texts, displayName } =
    useContext(LanguageContext);

  const handleSelect = (langCode) => {
    setCurrentLang(langCode);
    setOpenLang(false);
    setOpenMobileLang(false);
  };

  return (
    <div className="nav-buttons">
      {/* Desktop Order + Language */}
      <Link to="/order" className="flex1 order">{texts.navbar.order}</Link>

      {/* Desktop language dropdown */}
      <div className="language-dropdown">
        <button className="language" onClick={() => setOpenLang(!openLang)}>
          {displayName[currentLang]} ▾
        </button>

        {openLang && (
        <div className="dropdown-content">
          <button onClick={() => handleSelect("ar")}>العربية</button>
          <button onClick={() => handleSelect("ku")}>کوردی</button>
          <button onClick={() => handleSelect("en")}>English</button>
        </div>
        )}
      </div>

      {/* Burger menu icon */}
      <HiOutlineBars3
        className="burgerMenu"
        size={30}
        color="#fff"
        onClick={() => setMenuOpen(true)}
      />

      {/* Mobile full-screen menu */}
      {menuOpen && (
        <div className="mobile-menu-full">
          <button className="close-btn" onClick={() => setMenuOpen(false)}>
            <HiXMark size={30} color="#fff" />
          </button>

          <div className="mobile-logo">
            <img
              src={require("../../../assets/images/logo.png")}
              alt="MHERO Logo"
              className="mobile-logo-img"
            />
          </div>

          {/* Swiper slides for mobile navigation */}
          {/* <Swiper
            modules={[Pagination]}
            pagination={{ clickable: true }}
            className="menu-swiper"
          >
            <SwiperSlide>
              <div className="mobile-links">
                <Link to="/aboutUs" onClick={() => setMenuOpen(false)}>
                  {texts.navbar.aboutUs}
                </Link>
                <Link to="/contactUs" onClick={() => setMenuOpen(false)}>
                  {texts.navbar.contactUs}
                </Link>
                <Link to="/services" onClick={() => setMenuOpen(false)}>
                  {texts.navbar.services}
                </Link>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="mobile-links">
                <Link to="/order" onClick={() => setMenuOpen(false)}>
                  {texts.navbar.order}
                </Link>
                <Link to="/specification/MHERO1" onClick={() => setMenuOpen(false)}>
                  Specification MHERO1
                </Link>
                <Link to="/specification/MHERO2" onClick={() => setMenuOpen(false)}>
                  Specification MHERO2
                </Link>
                <Link to="/events" onClick={() => setMenuOpen(false)}>
                  Events & Activities
                </Link>
                <Link to="/companyProfile" onClick={() => setMenuOpen(false)}>
                  Distributor Profile
                </Link>
              </div>
            </SwiperSlide>
          </Swiper> */}

          {/* <Swiper
  modules={[Pagination]}
  pagination={{ clickable: true }}
  className="menu-swiper"
> */}
  {/* SLIDE 1 */}
  {/* <SwiperSlide> */}
    <div className="mobile-links">
     

       <button
      className="mobile-dropdown-toggle"
      onClick={() => setOpenYourMhero(!openYourMhero)}
    >
      {texts.navbar.yourMhero}
  {openYourMhero ? (
    <FiChevronUp size={20} className="arrow-up" />
  ) : (
    <FiChevronDown size={20} className="arrow-down" />
  )}
    </button>

    {/* SUBMENU */}
    {openYourMhero && (
      <div className="mobile-submenu">

        <Link to="/order" onClick={() => setMenuOpen(false)}>
          {texts.navbar.buildYourMhero}
        </Link>

        <Link to="/testDrive" onClick={() => setMenuOpen(false)}>
          {texts.navbar.testDrive}
        </Link>

        <div className="mobile-sub-card">
          <Link
            to="/specification/MHERO1"
            onClick={() => setMenuOpen(false)}
          >
            {texts.navbar.specificationsMhero1}
          </Link>
        </div>

        <div className="mobile-sub-card">
          <Link
            to="/specification/MHERO2"
            onClick={() => setMenuOpen(false)}
          >
            {texts.navbar.specificationsMhero2}
          </Link>
        </div>

      </div>
    )}

     <Link to="/aboutUs" onClick={() => setMenuOpen(false)}>
        {texts.navbar.aboutUs}
      </Link>
      <Link to="/contactUs" onClick={() => setMenuOpen(false)}>
        {texts.navbar.contactUs}
      </Link>
      <Link to="/services" onClick={() => setMenuOpen(false)}>
        {texts.navbar.services}
      </Link>

     <button
      className="mobile-dropdown-toggle"
      onClick={() => setOpenExploreMobile(!openExploreMobile)}
    >
      {texts.navbar.explore}
  {openExploreMobile ? (
    <FiChevronUp size={20} className="arrow-up" />
  ) : (
    <FiChevronDown size={20} className="arrow-down" />
  )}
    </button>

    {/* Submenu */}
    {openExploreMobile && (
      <div className="mobile-submenu">

        <Link
          to="/events"
          onClick={() => setMenuOpen(false)}
          className="mhero-mobile-spec"
        >
          {texts.navbar.eventsActivities}
        </Link>

        <Link
          to="/companyProfile"
          onClick={() => setMenuOpen(false)}
          className="mhero-mobile-spec"
        >
          {texts.navbar.distributorProfile}
        </Link>

        <Link
          to="/ourShowrooms"
          onClick={() => setMenuOpen(false)}
          className="mhero-mobile-spec"
        >
          {texts.navbar.ourShowrooms}
        </Link>

      </div>
    )}
    </div>



 



          {/*Mobile language dropdown */}
          <div className="mobile-language-section">
            <button
              className="language-mobile"
              onClick={() => setOpenMobileLang(!openMobileLang)}
            >
              {displayName[currentLang]} ▾
            </button>

            {openMobileLang && (
              <div className="mobile-dropdown-content">
                <button onClick={() => handleSelect("ar")}>Arabic</button>
                <button onClick={() => handleSelect("ku")}>Kurdish</button>
                <button onClick={() => handleSelect("en")}>English</button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NavbarButtons;
